import {
  SelectedLinesInfo,
  buildMultilineAction,
  addLineIndent,
} from '../utils'
import { matchList } from '../listUtils'
import { markdownConfig } from '../../config'

const computeUnindentStep = (info: SelectedLinesInfo): number | null => {
  const defaultStep = Math.max(0, markdownConfig.defaultIndent)
  const firstLine = info.lines[0] ?? ''
  const firstMatch = matchList(firstLine)

  if (!firstMatch) return null

  const curIndentLen = (firstMatch[1] || '').length

  // Find the nearest shallower indentation (parent level) if any.
  let parentIndentLen = 0
  let parentMarkerLen = defaultStep

  const beforeText = info.before
  let pos = beforeText.length - 2 // -2 to skip the last newline
  while (pos >= 0) {
    const prevNl = beforeText.lastIndexOf('\n', pos)
    const line = beforeText.slice(prevNl + 1, pos + 1)

    const m = matchList(line)
    if (!m) break

    const indLen = (m[1] || '').length

    if (indLen < curIndentLen) {
      parentIndentLen = indLen
      parentMarkerLen = (m[2] || '').length || defaultStep
      break
    }

    // Move to the previous line (character before the newline)
    pos = prevNl - 1
  }

  const parentOrSiblingWithMarkerIndentLen = parentIndentLen + parentMarkerLen

  if (parentOrSiblingWithMarkerIndentLen < curIndentLen) {
    return -(curIndentLen - parentOrSiblingWithMarkerIndentLen)
  }

  return -(curIndentLen - parentIndentLen)
}

export const unindentListAction = buildMultilineAction(
  computeUnindentStep,
  addLineIndent,
)
